import NotFound from '@src/pages/NotFound';
import { createFileRoute } from '@tanstack/react-router';

import { loadContactName } from '../clientTitle';
import { getLocalizedDynamicTitle } from '../title';

export const Route = createFileRoute(
  '/_app/clients/representatives/$contactId',
)({
  loader: async ({ context, params }) => ({
    contactName: await loadContactName(context.apiClient, params.contactId),
  }),
  head: ({ loaderData }) => ({
    meta: [
      {
        title: getLocalizedDynamicTitle(
          'clients.contact_detail.page_title',
          'Client contact detail',
          loaderData?.contactName ?? '',
        ),
      },
    ],
  }),
  // A contact that does not exist or that the user may not view.
  notFoundComponent: NotFound,
});
